import { render, staticRenderFns } from "./arksnackbar.vue?vue&type=template&id=4210ec52&"
import script from "./arksnackbar.vue?vue&type=script&lang=js&"
export * from "./arksnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports